import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { PrismicReusableContentDataBodyRichTextV2 } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { graphql } from "gatsby";

export const query = graphql`
  fragment RichTextV2Module on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyRichTextV2 {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
      }
    }
  }
`;

export type IRichTextProps = {
  slice: PrismicReusableContentDataBodyRichTextV2;
};

const RichText = (props: IRichTextProps) => {
  const { slice } = props;
  const { primary } = slice;

  return (
    <div className={primary?.css_class || ""}>
      <PrismicRichText
        field={primary.heading.richText}
        components={htmlSerializer}
      />
      <PrismicRichText
        field={primary.description.richText}
        components={htmlSerializer}
      />
    </div>
  );
};

export default RichText;
